export const staging = {
  orchestratorServer: {
    baseUri: 'https://staging-cx-api.prospa.com',
  },
};
